export default "__VITE_ASSET__8v5_ZZ3q__"